const logItemNoShipStates = (sku) => {
  const params = {
    message: `Item has no ship states: ${sku}`,
    properties: sku,
  };

  fetch(`${window.apiBaseUrl}/logs?${new URLSearchParams(params)}`).then((result) => result.json()).then((data) => {
    console.log('Item has no ship states Logged - ', data);
  });
};

const disableAddToCart = (selectedState) => {
  const $shipWarning = document.getElementById('shipWarning');
  const $addToCartButton = document.querySelector('.product-form__cart-submit');
  if ($shipWarning) {
    $shipWarning.style.display = 'block';
    $shipWarning.innerText = `This product can not be shipped to ${selectedState}.`;
  }
  if ($addToCartButton) {
    $addToCartButton.setAttribute('disabled', 'disabled');
    $addToCartButton.style.pointerEvents = 'none';
  }
};

const enableAddToCart = () => {
  const $shipWarning = document.getElementById('shipWarning');
  const $addToCartButton = document.querySelector('.product-form__cart-submit');
  if ($shipWarning) {
    $shipWarning.style.display = 'none';
    $shipWarning.innerText = '';
  }
  if ($addToCartButton) {
    $addToCartButton.removeAttribute('disabled');
    $addToCartButton.style.pointerEvents = 'all';
  }
};

// eslint-disable-next-line consistent-return
const validateShippingCategory = (shippingCategory, selectedState) => {
  if (shippingCategory && shippingCategory.length) {
    const category = shippingCategory[0].split(':')[1].trim().toLowerCase();
    let shipStatesMap = {};
    // eslint-disable-next-line consistent-return,no-undef
    return getShipStatesMap().then((data) => {
      if (data.ship_states) {
        shipStatesMap = data.ship_states;

        if (shipStatesMap[category]
          && shipStatesMap[category].length
          && !shipStatesMap[category].includes(selectedState)
        ) {
          disableAddToCart(selectedState);
          return false;
        }
        enableAddToCart();
        return true;
      }
    }).catch((error) => {
      console.log('Config Error - ', error);
      enableAddToCart();
      return true;
    });
  }
};

const setProductSoldOut = () => {
  const $price = document.querySelector('.js-regular-price strong');
  const $priceText = $price ? $price.innerText.toLowerCase() : false;
  const comingSoon = $priceText === 'coming soon';

  if ($price && !comingSoon) {
    $price.innerHTML = 'SOLD OUT';
    const $productOptions = document.querySelector('.product__options-wrap');
    if ($productOptions) {
      $productOptions.remove();
    }
    const $productForm = document.querySelector('.product-form');
    if ($productForm) {
      $productForm.remove();
    }
  }
};

const validateStateAvailability = (sku, selectedState) => {
  const params = {
    state: selectedState,
    'skus[]': sku,
    shippable_states: 'yes',
  };

  fetch(`${window.apiBaseUrl}/availability/simple?${new URLSearchParams(params)}`)
    .then((response) => response.json()).then((result) => {
      const items = result.data.results;
      if (Object.entries(items).length > 0) {
        let valid = true;
        Object.entries(items).forEach((item) => {
          if (item[1].shippable_states.length
            && !item[1].shippable_states.includes(selectedState)
          ) {
            // eslint-disable-next-line no-undef
            logItemNotAvailable(sku, selectedState, items);
            disableAddToCart(selectedState);
            valid = false;
          } else if (!item[1].shippable_states.length && [...new Set(sku.split('|'))].length <= 1) {
            setProductSoldOut();
            logItemNoShipStates(sku);
          }
        });
        return valid;
      }
      return true;
    }).catch((error) => {
      rollBarError('RB_AVAILABILITY_API: Error Checking Product Availability', error);
    });

  enableAddToCart();
};

const validateSelectedStateAvailability = (state = null) => {
  const selectedState = state || localStorage.getItem('selectedstate');

  if (selectedState) {
    const tags = SDG?.Data?.product?.tags;
    const sku = SDG?.Data?.productVariants[0].sku || null;
    if (tags.length && sku) {
      const shippingCategory = tags.filter((tag) => tag.includes('Shipping Category'));
      if (shippingCategory) {
        validateShippingCategory(shippingCategory, selectedState).then((shippingCategoryValid) => {
          if (shippingCategoryValid) {
            if (shippingCategoryValid) {
              validateStateAvailability(sku, selectedState);
            }
          }
        });
      }
    }
  }
};

const getShippableStatesForBundle = (result, sku) => {
  const shippableStatesArray = [];
  let bundleIsShippable = true;
  sku.split('|').forEach((bundleSku) => {
    const bundleResults = result.data.results[bundleSku.toLowerCase()];
    if (bundleResults
      && bundleResults.shippable_states
    ) {
      // eslint-disable-next-line camelcase
      const { shippable_states } = bundleResults;
      // eslint-disable-next-line camelcase
      shippableStatesArray.push(shippable_states);
    }
  });

  // eslint-disable-next-line consistent-return
  shippableStatesArray.forEach((shippableStates) => {
    if (!shippableStates.length) {
      bundleIsShippable = false;
    }
  });

  return bundleIsShippable ? [...new Set(shippableStatesArray
    .shift()
    .filter((v) => shippableStatesArray.every((a) => a.indexOf(v) !== -1))
    .flat())] : [];
};

const getAvailableStatesBySku = (sku, selectedState) => {
  const params = {
    state: selectedState,
    'skus[]': sku,
    shippable_states: 'yes',
  };

  fetch(`${window.apiBaseUrl}/availability/simple?${new URLSearchParams(params)}`)
    .then((response) => response.json()).then((result) => {
      if (sku.split('|').length > 1) {
        const shippableStates = getShippableStatesForBundle(result, sku);
        if (!shippableStates.length) {
          setProductSoldOut();
          logItemNoShipStates(sku);
        } else {
          updateProductAvailableStates(shippableStates);
        }
      } else if (result.data.results[sku.toLowerCase()]
        && result.data.results[sku.toLowerCase()].shippable_states
      ) {
        if (!result.data.results[sku.toLowerCase()].shippable_states.length) {
          setProductSoldOut();
          logItemNoShipStates(sku);
        } else {
          updateProductAvailableStates(result.data.results[sku.toLowerCase()].shippable_states);
        }
      }
    });
};

const statesMap = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'America Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FM: 'Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Island',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

const updateProductAvailableStates = (availableStates) => {
  const $productAvailableStatesEl = document.querySelector('.product-available-states');
  const $productAvailableStatesLeftEl = document.querySelector('.product-available-states-left');
  const $stateAvailability = document.querySelector('.product-form .state-availability');
  const $stateAvailabilityLeft = document.querySelector('.product__description .state-availability');
  if ($productAvailableStatesEl && availableStates.length) {
    $productAvailableStatesEl.innerText = availableStates.join(', ');
    if ($stateAvailability) {
      $stateAvailability.style.display = 'block';
    }
  }
  if ($productAvailableStatesLeftEl && availableStates.length) {
    const availableStatesFull = availableStates.map((state) => statesMap[state] || state);
    $productAvailableStatesLeftEl.innerText = availableStatesFull.join(', ');
    if ($stateAvailabilityLeft) {
      $stateAvailabilityLeft.style.display = 'block';
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const $shippingCategoryProp = document.getElementById('shipping-category-prop');
  const sku = SDG?.Data?.productVariants[0].sku || null;
  const selectedState = localStorage.getItem('selectedstate');
  getAvailableStatesBySku(sku, selectedState);
  if ($shippingCategoryProp) {
    const tags = SDG?.Data?.product?.tags;
    if (tags.length) {
      const shippingCategory = tags.filter((tag) => tag.includes('Shipping Category'));
      if (shippingCategory) {
        $shippingCategoryProp.value = shippingCategory[0].split(':')[1].trim().toLowerCase().replace(' ', '-');
      }
    }
  }
  validateSelectedStateAvailability();
});

window.addEventListener('customerLocation', (data) => {
  validateSelectedStateAvailability(data.detail?.state || null);
});
